
import { defineComponent, PropType } from 'vue'
import LanguageSwitcher from '../../components/sharable/LanguageSwitcher.vue'
import MainNavigation from './MainNavigation.vue'
import { useI18n } from 'vue-i18n'

type MaybeAsyncCallback = () => void | Promise<void>

export default defineComponent({
  name: 'MainHeader',
  components: {
    LanguageSwitcher,
    MainNavigation,
  },
  props: {
    onLogin: {
      type: Function as PropType<MaybeAsyncCallback>,
      default: undefined,
    },
    onReg: {
      type: Function as PropType<MaybeAsyncCallback>,
      default: undefined,
    },
  },
  data() {
    return {
      lang: localStorage.getItem('lang') || 'RU',
      menuVisible: false,
    }
  },
  methods: {
    toggleMenu() {
      this.menuVisible = !this.menuVisible
    },
    changeLang(lang: string) {
      this.$i18n.locale = lang
      localStorage.setItem('lang', lang)
    },
    async goLogin() {
      if (this.onLogin) {
        await this.onLogin()
        return
      }
      window.location.href = '/login'
    },
    async goReg() {
      if (this.onLogin) {
        await this.onLogin()
        return
      }
      window.location.href = '/registration'
    },
  },
  setup() {
    const { locale, availableLocales } = useI18n({ useScope: 'global' })

    return {
      localeState: locale,
      localeOptions: availableLocales,
    }
  },
})
